// ISO java.time.DayOfWeek numbering: 1=Monday … 7=Sunday. Both directions
// of this mapping must agree — historically dayNumbersToText was
// Sunday-first while dayTextToNumber was ISO, which silently shifted the
// preselected day in edit mode.
const ISO_DAY_NUMBER_TO_NAME = {
  1: "monday",
  2: "tuesday",
  3: "wednesday",
  4: "thursday",
  5: "friday",
  6: "saturday",
  7: "sunday",
};

const ISO_DAY_NAME_TO_NUMBER = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7,
};

export const dayNumbersToText = (days) =>
  days.map((day) => ISO_DAY_NUMBER_TO_NAME[Number(day)]).filter(Boolean);

export const dayTextToNumber = (dayName) =>
  ISO_DAY_NAME_TO_NUMBER[String(dayName).toLowerCase()] ?? null;
